import type { RemediationOptionItem } from "@repo/api/schemas/policies.schema";
import "./Accordion.css";

import { Box, Typography } from "@saviynt/design-system";
import { useState } from "react";
import { AccordionHeader } from "./AccordionHeader";
import { HtmlRenderer } from "@repo/mfe-core";

interface AccordionProps {
  options: RemediationOptionItem[];
}

interface TextBlock {
  textType: string;
  text: string;
}

function TextBlockItem({ textBlock }: { textBlock: TextBlock }) {
  if (textBlock.textType.toLowerCase() === "code") {
    return (
      <div className="rounded-lg nhi-desc-bg p-4">
        <Typography
          kind="body2"
          desktop="body2-d"
          mobile="body2-d"
          color="--color-foreground-secondary-bold"
        >
          {textBlock.text}
        </Typography>
      </div>
    );
  }

  return (
    <Typography
      kind="body2"
      desktop="body2-m"
      mobile="body2-m"
      color="--color-foreground-neutral-subtle"
    >
      <HtmlRenderer htmlString={textBlock.text || ""} />
    </Typography>
  );
}

export default function Accordion({ options }: AccordionProps) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const toggleExpanded = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <>
      {options.map((option, optionIndex) => {
        const { optionName = " ", remediationSteps = [] } = option;
        const isExpanded = expandedIndex === optionIndex;
        const isNumbered = remediationSteps.length > 1;

        return (
          <Box key={optionIndex} className="policies-accordion-container">
            <AccordionHeader
              title={optionName}
              isExpanded={isExpanded}
              onToggle={() => toggleExpanded(optionIndex)}
            />

            {isExpanded && (
              <Box className="policies-accordion-body">
                <ol
                  className={`policies-accordion-step${isNumbered ? " policies-numbered-list" : ""}`}
                >
                  {remediationSteps.map((step, stepIndex) =>
                    step.textBlocks.map((textBlock, blockIndex) => (
                      <li key={`${stepIndex}-${blockIndex}`}>
                        <TextBlockItem textBlock={textBlock} />
                      </li>
                    )),
                  )}
                </ol>
              </Box>
            )}
          </Box>
        );
      })}
    </>
  );
}
